import { htmlToWordsArray } from '../htmlToWordsArray';
import { generateBreadcrumbScheme } from './breadcrumbs';
import { organization } from './organization';
import { rootUrl as baseUrl } from './shared';
import { generateWebPageSchema } from './webpage';
import { website } from './website';
import { generateFaqSchema } from './faq';

const generateAuthor = name => {
  return [
    {
      '@type': 'Person',
      name: name ? name : 'hipages'
    }
  ];
};

const generateImage = image => {
  let link = image;
  if (typeof image !== 'string') {
    link =
      'https://thumbnail-cloud.homeimprovementpages.com.au/unsafe/2560x0/smart/https://mediacache.homeimprovementpages.com.au/creative/articles/hip/2088/article_original_image.jpg?v=1';
  }
  return [link];
};

const generateAbout = ({ topic, secondaryTopics, category, title, path }) => {
  let result = [];
  if (category && category.name && category.key) {
    result = [
      ...result,
      { '@type': 'Thing', name: category.name, url: `${baseUrl}/find/${category.key}` }
    ];
  }
  if (topic && topic.name && topic.key) {
    result = [...result, { '@type': 'Thing', name: topic.name, url: `${baseUrl}/c/${topic.key}` }];
  }
  if (secondaryTopics.length > 0) {
    secondaryTopics.forEach(i => {
      if (i && i.name && i.key) {
        result = [...result, { '@type': 'Thing', name: i.name, url: `${baseUrl}/c/${i.key}` }];
      }
    });
  }
  if (result.length === 0) {
    result = [...result, { '@type': 'Thing', name: title, url: `${baseUrl + path}` }];
  }

  return result;
};

export const generateArticleSchema = data => {
  const {
    path,
    title,
    category,
    topic,
    secondaryTopics,
    body,
    lastModified,
    createdDate,
    author,
    metaDesc,
    readingTime,
    breadcrumbsData,
    image,
    faq
  } = data;
  const words = htmlToWordsArray(body);
  const hasBreadcrumbs = breadcrumbsData.length > 0;
  return {
    '@graph': [
      organization,
      website,
      generateWebPageSchema({ path, hasBreadcrumbs }),
      generateBreadcrumbScheme(breadcrumbsData, path),
      {
        '@context': 'http://schema.org',
        '@type': 'Article',
        '@id': `${baseUrl + path}#article`,
        publisher: {
          '@id': `${baseUrl}/#organization`
        },
        author: generateAuthor(author),
        headline: title,
        description: metaDesc,
        speakable: {
          '@type': 'SpeakableSpecification',
          cssSelector: ['speakable']
        },
        image: generateImage(image),
        datePublished: createdDate,
        dateModified: lastModified,
        wordCount: words.length,
        timeRequired: `${Math.ceil(readingTime)}M`,
        inLanguage: 'en',
        mainEntityOfPage: {
          '@id': `${baseUrl + path}#webpage`
        },
        about: generateAbout({ topic, category, secondaryTopics, title, path })
      },
      ...generateFaqSchema(faq)
    ]
  };
};
